import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import axios from 'axios';

import {
  Status,
  I18n, Button,
} from 'components';
import { formatDateString } from 'utils/formatString';

import { emptyObj } from '@beef/utils';
import styles from './styles.pcss';
import { Link, Preloader, RadioButton, RadioGroup } from '../../../../components';
import { getWifiRouterReturnInfoRequest } from '../../api/requests';
import { OWNERSHIP_TYPE, RETURN_OPTION_TYPE } from '../../constants';

const cx = classNames.bind(styles);

export class Device extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAliasFormVisible: false,
      isReturnFormVisible: false,
      alias: this.props.alias,
      error: null,
      returnParams: null,
      returnOption: null,
    };
  }

  returnDevice = () => {
    const { RentReturnConsole } = window?.QA?.Beeline?.Pages?.HomeTariff || emptyObj;

    this.setState({ isReturnFormVisible: false });

    try {
      RentReturnConsole.ShowRentReturnCard({
        IsSubmit: false,
        Action: RentReturnConsole.RentActionTypeEnum().Return,
        EquipmentsType: RentReturnConsole.EquipmentTypeEnum().Console,
      });
    } catch (error) {
      this.setState({ error });
    }
  }

  toggleAliasForm = () => this.setState((prevState) => ({
    isAliasFormVisible: !prevState.isAliasFormVisible,
    isReturnFormVisible: false,
    error: null,
  }))

  saveAlias = async (event) => {
    event.preventDefault();

    const { routerSerial } = this.props;
    const alias = event.target.elements.alias.value.trim();

    this.setState({
      isAliasFormVisible: false,
      alias,
    });

    const { data } = await axios.post('/api/profile/convergence/equipmentalias/', {
      equipmentId: routerSerial,
      equipmentType: 'RTR',
      alias,
    });

    if (!data.isSuccess) {
      this.setState({
        alias: this.props.alias,
        error: {
          message: 'Ошибка при сохранении метки',
          code: data.errorCode,
        },
      });
    }
  }

  toggleReturnForm = async () => {
    this.setState((prevState) => ({
      isReturnFormVisible: !prevState.isReturnFormVisible,
      isAliasFormVisible: false,
      error: null,
    }));
    if (this.state.returnParams) return;

    const { routerSerial } = this.props;

    getWifiRouterReturnInfoRequest(routerSerial)
      .then(({ data }) => data)
      .then((data) => {
        if (data) {
          this.setState({
            returnParams: data,
            returnOption: data.courier?.enabled ? RETURN_OPTION_TYPE.courier : RETURN_OPTION_TYPE.office,
          });
        } else {
          this.setState({
            error: {
              message: 'При выполнении операции произошла ошибка. Попробуйте еще раз',
            },
            isReturnFormVisible: false,
          });
        }
      }).catch((error) => {
        this.setState({ error, isReturnFormVisible: false });
      });
  }

  render() {
    const {
      price,
      ownershipType,
      routerSerial,
      routerModel,
    } = this.props;
    const {
      error,
      returnParams,
      returnOption,
      isReturnFormVisible,
    } = this.state;

    return (
      <div className={cx('component')}>
        <div className={cx('device')}>
          <div className={cx('type')}>
            Роутер
          </div>

          <div className={cx('name')}>
            {routerModel}
            {isReturnFormVisible && (
              <Status className={cx('returnForm')}>
                {returnParams ? (
                  <>
                    <div className={cx('formName')}>
                      Выберите способ возврата приставки
                    </div>
                    <RadioGroup
                      className={cx('returnOptions')}
                      value={returnOption}
                      onChange={(value) => this.setState({ returnOption: value })}
                      name={`return-options-${routerSerial}`}
                    >
                      {returnParams.courier?.enabled && (
                        <RadioButton value="courier">
                          <span className={cx('returnOptionName')}>
                            Вернуть с курьером
                          </span>
                          {returnParams.courier.price}
                          {' '}
                          ₽
                        </RadioButton>
                      )}
                      {returnParams.office?.enabled && (
                        <RadioButton value="office">
                          <span className={cx('returnOptionName')}>
                            Привезти в офис самому
                          </span>
                          Бесплатно
                        </RadioButton>
                      )}
                    </RadioGroup>
                    {returnOption === RETURN_OPTION_TYPE.courier && (
                      <div className={cx('formControls')}>
                        <Button
                          className="default"
                          onClick={this.returnDevice}
                        >
                          К возврату
                        </Button>
                        <Link
                          className={cx('formLink')}
                          onClick={this.toggleReturnForm}
                        >
                          Отменить
                        </Link>
                      </div>
                    )}
                    {returnOption === RETURN_OPTION_TYPE.office && (
                      <div className={cx('returnText')}>
                        Вы можете вернуть приставку в одном из
                        {' '}
                        <Link href={returnParams.office.link} target="_blank">
                          наших офисов
                        </Link>
                        {' '}
                        или
                        {' '}
                        <Link onClick={this.toggleReturnForm}>
                          отменить возврат
                        </Link>
                      </div>
                    )}
                  </>
                ) : (
                  <Preloader
                    className={cx('preloader')}
                    size="48"
                  />
                )}
              </Status>
            )}
          </div>

          <div className={cx('info')}>
            <div>
              <I18n
                className={cx('serical')}
                path="internet.devices.serial"
                vars={{ serial: routerSerial }}
              />
            </div>
            {(ownershipType === OWNERSHIP_TYPE.RENT) && !isReturnFormVisible && (
              <div className={cx('backLink')}>
                <Link onClick={this.toggleReturnForm}>
                  Вернуть приставку
                </Link>
              </div>
            )}
          </div>

          <div className={cx('price')}>
            {ownershipType === OWNERSHIP_TYPE.RENT && (
              <>
                <div className={cx('status')}>
                  В аренде
                </div>
                <I18n
                  path="common.pricePerMonth"
                  vars={{ sum: price }}
                />
              </>
            )}
            {ownershipType === OWNERSHIP_TYPE.BUYED && OWNERSHIP_TYPE.BUY}
            {ownershipType === OWNERSHIP_TYPE.GIFT && OWNERSHIP_TYPE.PRESENT}
          </div>
        </div>

        {error?.message && (
          <Status className={[cx('error'), 'error']} emoji="statusFail">
            {error.message}
          </Status>
        )}
      </div>
    );
  }
}

Device.propTypes = {
  alias: PropTypes.string,
  price: PropTypes.number,
  ownershipType: PropTypes.string,
  routerSerial: PropTypes.string,
  routerModel: PropTypes.string,
};
